const CONSTANTS = require('../../constants');

module.exports = {
  staticResources: {
    dropDowns: {
      status: {
        // textNone: 'Bitte wählen Sie',
        // errorMessage: 'Bitte treffen Sie eine Auswahl',
        content: ['Noch nicht freigegeben', 'In Bearbeitung', 'Erfolgreich abgeschlossen', 'Storniert']
      },
      statusDetails: {
        // errorMessage: 'Bitte treffen Sie eine Auswahl',
        content: [
          '',
          'Besetzung durch anderen DL',
          'Einstellungsstopp',
          'Interne Besetzung',
          'keine passenden Profile generiert',
          'Position on hold',
          'Prof. Zusammenarbeit unmöglich',
          'Streichung Position',
          'Unternehmen besetzt selbst'
        ]
      },
      serviceType: {
        // errorMessage: 'Bitte treffen Sie eine Auswahl',
        content: [
          '',
          'Platzierung',
          CONSTANTS.isLienert && 'Platzierung VR',
          'Beratung',
          CONSTANTS.isSenator ? 'Direct Search' : { label: 'Direktsuche', value: 'Direct Search' },
          'Executive Search',
          'Anzeigenschaltung',
          'Online-Platzierung',
          'Assessment',
          'Coaching'
        ].filter(Boolean)
      }
    }
  }
};
